import types from '../actions/graph.actions';
import formTypes from '../actions/form.actions';
//import menuTypes from '../actions/menu.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {

        case types.INTELLIGENCE_SEARCH_ENTITIES:
            return {
                ...state,
                graph: {
                    ...state.graph,
                    entidades: [],
                    vinculos: [],
                    search: action.payload.text,
                    successMessage: '',
                    errorMessage: '',
                    status: 'LOADING'
                }
            }

        case types.INTELLIGENCE_SEARCH_EXPAND_ENTITIES:
        case types.INTELLIGENCE_EXPAND_DINARDAP_ENTITIES:
            return {
                ...state,
                graph: {
                    ...state.graph,
                    search: action.payload.text,
                    successMessage: '',
                    errorMessage: '',
                    status: 'LOADING'
                }
            }

        case types.INTELLIGENCE_STORE_ENTITIES:

            if (action.payload.metadata[0].codigo == 200) {

                let entities = [...state.graph.entidades];
                let edges = [...state.graph.vinculos];

                action.payload.response.data.forEach((item) => {
                    item.entidades.forEach((entidad) => {

                        // Agrega entidades resultados de la busqueda
                        const existEnt = state.graph.entidades.find((node) => node.id.toUpperCase() === entidad.entityId.toUpperCase());

                        if (!existEnt) {
                            entities.push({
                                id: entidad.entityId,
                                label: entidad.label,
                                type: entidad.type.toUpperCase(),
                                text: entidad.text,
                                source: entidad.source,
                                origin: entidad.origin,
                                coordinates: entidad.coordinates,
                                props: {
                                    ...entidad.props
                                }
                            })
                        }
                    });

                    item.vinculos.forEach((vinculo) => {
                        // Agrego y valido que no existan vinculos
                        const existEdge = state.graph.vinculos.find((edge) => (edge.fromId.toUpperCase() == vinculo.fromId.toUpperCase() && edge.toId.toUpperCase() == vinculo.toId.toUpperCase()));

                        if (!existEdge) {
                            edges.push({
                                fromId: vinculo.fromId,
                                toId: vinculo.toId,
                                label: vinculo.label,
                                source: vinculo.source,
                                origin: vinculo.origin,
                                props: {
                                    ...vinculo.props
                                }
                            })
                        }
                    });
                });

                return {
                    ...state,
                    graph: {
                        ...state.graph,
                        entidades: entities,
                        vinculos: edges,
                        successMessage: action.payload.metadata[0].dato,
                        status: 'LOADED'
                    }
                }

            } else {
                return {
                    ...state,
                    graph: {
                        ...state.graph,
                        errorMessage: action.payload.metadata[0].dato,
                        status: 'LOADED'
                    }
                }
            }

        case formTypes.INTELLIGENCE_FORMS_GET_DATA:
            return {
                ...state,
                formularios: {
                    ...state.formularios,
                    formId: '',
                    status: 'LOADING'
                }
            }

        case formTypes.INTELLIGENCE_FORMS_STORE_DATA:

            return {
                ...state,
                formularios: {
                    ...state.formularios,
                    formId: action.payload.formId,
                    data: action.payload.data,
                    status: 'LOADED'
                }
            }

        case formTypes.INTELLIGENCE_FORMS_CHANGE_STATUS_FORM:
            return {
                ...state,
                formularios: {
                    ...state.formularios,
                    formId: action.payload.formId,
                    successMessage: (action.payload.data.metadata[0].codigo === '200') ? action.payload.data.metadata[0].dato : '',
                    errorMessage: (action.payload.data.metadata[0].codigo !== '200') ? action.payload.data.metadata[0].dato : '',
                    formData: (action.payload.data.metadata[0].codigo === '200') ? action.payload.data.response.data : [],
                    status: (action.payload.data.metadata[0].codigo === '200') ? 'RELOAD' : 'LOADED'
                }
            }

        case formTypes.INTELLIGENCE_FORMS_CLEAR_MESSAGES:
            return {
                ...state,
                formularios: {
                    ...state.formularios,
                    successMessage: '',
                    errorMessage: ''
                }
            }

        /*case menuTypes.INTELLIGENCE_MENU_SET_ACTION:
            return {
                ...state,
                menu: {
                    action: action.payload.action
                }
            }

        case menuTypes.INTELLIGENCE_MENU_REMOVE_ACTION:
            return {
                ...state,
                menu: {
                    action: null
                }
            }*/

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    graph: {
        search: '',
        entidades: [],
        vinculos: [],
        successMessage: '',
        errorMessage: '',
        status: null
    },
    formularios: {
        data: [],
        formData: [],
        successMessage: '',
        errorMessage: '',
        status: '',
        formId: ''
    },
    menu: {
        action: null
    }
};